import { createI18n } from 'vue-i18n'
import { compile, registerMessageCompiler } from '@intlify/core-base'
import en from './locales/en'

// @intlify/unplugin-vue-i18n precompiles locale messages into AST resources at
// build time (see vite.config.ts), and the production build aliases 'vue-i18n'
// to its runtime-only build so no eval-based JIT compiler ships to the browser
// (required for CSP script-src without 'unsafe-eval'). The runtime-only build
// does not wire up any message compiler by default, even to just interpret an
// already-precompiled AST — it must be registered explicitly, or `t()` throws
// at the first call (vue-i18n's own internal "did this resolve to a string?"
// check fails and it raises an error). `compile` here is @intlify/core-base's
// AST interpreter: for a precompiled AST resource it returns a plain closure
// that walks the AST at call time — no `new Function()`/eval involved, so this
// keeps the CSP guarantee this whole precompilation setup exists for.
registerMessageCompiler(compile)

const i18n = createI18n({
  legacy: false,
  locale: 'en',
  messages: { en },
})

export default i18n
